<template>
  <v-dialog
    width="50vw"
    max-width="800px"
    persistent>
    <v-card class="pa-5">
      <v-card-title> Server Maintenenance </v-card-title>
      <v-card-subtitle class="pl-0">
        Scheduling App is down for maintenance. Please try again later.
      </v-card-subtitle>
      <v-card-text />
      <v-card-actions>
        <v-spacer />
        <PrimaryButton
          @click="reload"
          variant="text">
          Reload
        </PrimaryButton>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script setup lang="ts">
import { PrimaryButton } from "@/components/buttons";

const reload = () => location.reload();
</script>